import React, { useContext, useMemo, useState, useEffect, useRef } from 'react';
import { mergeAnatomies, coreAnatomy, helperAnatomy, styledAnatomyFactory, attachDataAttr } from '@icecreamsocial/anatomy';
import PropTypes from 'prop-types';
import styled, { css, createGlobalStyle, ThemeContext, keyframes } from 'styled-components';
import ReactSelect, { components } from 'react-select';
import Modal from 'styled-react-modal';
import { useImage } from 'react-image';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var anatomy = mergeAnatomies(coreAnatomy, helperAnatomy);
var slateStyles = styledAnatomyFactory(anatomy);
var Slate = slateStyles('Slate');

var _templateObject$k, _templateObject2$8, _templateObject3$7, _templateObject4$7, _templateObject5$4, _templateObject6$2, _templateObject7, _templateObject8, _templateObject9;
var H1 = Slate.h1.attrs(attachDataAttr('h1')())(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral([""])));
var H2 = Slate.h2.attrs(attachDataAttr('h2')())(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral([""])));
var H3 = Slate.h3.attrs(attachDataAttr('h3')())(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral([""])));
var H4 = Slate.h4.attrs(attachDataAttr('h4')())(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteral([""])));
var H5 = Slate.h5.attrs(attachDataAttr('h5')())(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteral([""])));
var H6 = Slate.h6.attrs(attachDataAttr('h6')())(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral([""])));
var P = Slate.p.attrs(function (_ref) {
  var typoHeight = _ref.typoHeight;
  return attachDataAttr('p')({
    typoHeight: typoHeight || 'lg'
  });
})(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral([""])));
var Span = Slate.span.attrs(attachDataAttr('span'))(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral([""])));
var A = Slate.a.attrs(function (_ref2) {
  var _ref2$textDecoration = _ref2.textDecoration,
    textDecoration = _ref2$textDecoration === void 0 ? 'underline' : _ref2$textDecoration,
    _ref2$textColor = _ref2.textColor,
    textColor = _ref2$textColor === void 0 ? 'link' : _ref2$textColor,
    _ref2$visitedTextColo = _ref2.visitedTextColor,
    visitedTextColor = _ref2$visitedTextColo === void 0 ? 'linkVisited' : _ref2$visitedTextColo;
  return attachDataAttr('a')({
    textDecoration: textDecoration,
    textColor: textColor,
    visitedTextColor: visitedTextColor
  });
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\topacity: 1;\n\ttransition: opacity 250ms ease;\n\tcursor: pointer;\n\n\t&:hover {\n\t\topacity: .75;\n\t\ttransition: opacity 250ms ease;\n\t}\n"])));

var Typography = /*#__PURE__*/Object.freeze({
  __proto__: null,
  H1: H1,
  H2: H2,
  H3: H3,
  H4: H4,
  H5: H5,
  H6: H6,
  P: P,
  Span: Span,
  A: A
});

function _typeof$2(o) {
  "@babel/helpers - typeof";

  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$2(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof$2(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof$2(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof$2(i) ? i : String(i);
}

function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var _excluded$e = ["shadow", "border", "borderRadius", "borderColor", "display", "flexDirection"];
var _templateObject$j, _templateObject2$7, _templateObject3$6, _templateObject4$6;
function ownKeys$l(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$l(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$l(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$l(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Panel = Slate.div.attrs(function (_ref) {
  var _ref$shadow = _ref.shadow,
    shadow = _ref$shadow === void 0 ? 'none' : _ref$shadow,
    _ref$border = _ref.border,
    border = _ref$border === void 0 ? 'default' : _ref$border,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? 'default' : _ref$borderRadius,
    _ref$borderColor = _ref.borderColor,
    borderColor = _ref$borderColor === void 0 ? 'ambient' : _ref$borderColor,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? 'flex' : _ref$display,
    _ref$flexDirection = _ref.flexDirection,
    flexDirection = _ref$flexDirection === void 0 ? 'column' : _ref$flexDirection,
    rest = _objectWithoutProperties(_ref, _excluded$e);
  return attachDataAttr('panel')(_objectSpread$l({
    shadow: shadow,
    border: border,
    borderRadius: borderRadius,
    borderColor: borderColor,
    display: display,
    flexDirection: flexDirection
  }, rest));
})(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n\ttransition: all 250ms cubic-bezier(0.075, 0.82, 0.165, 1);\n\t", ";\n"])), hoverRules);
Panel.Header = Slate.div.attrs(function (_ref2) {
  var theme = _ref2.theme,
    _ref2$padding = _ref2.padding,
    padding = _ref2$padding === void 0 ? 'lg' : _ref2$padding,
    _ref2$backgroundColor = _ref2.backgroundColor,
    backgroundColor = _ref2$backgroundColor === void 0 ? 'brand' : _ref2$backgroundColor,
    _ref2$textColor = _ref2.textColor,
    textColor = _ref2$textColor === void 0 ? 'bodyInverse' : _ref2$textColor,
    borderRadius = _ref2.borderRadius;
  return attachDataAttr('panel-header')({
    padding: padding,
    backgroundColor: backgroundColor,
    textColor: textColor,
    borderRadius: borderRadius || "".concat(theme.borders.radius["default"], " ").concat(theme.borders.radius["default"], " 0 0")
  });
})(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n"])));
Panel.Body = Slate.div.attrs(function (_ref3) {
  var _ref3$padding = _ref3.padding,
    padding = _ref3$padding === void 0 ? 'lg' : _ref3$padding,
    _ref3$flexGrow = _ref3.flexGrow,
    flexGrow = _ref3$flexGrow === void 0 ? '1' : _ref3$flexGrow;
  return attachDataAttr('panel-body')({
    padding: padding,
    flexGrow: flexGrow
  });
})(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral([""])));
Panel.Footer = Slate.div.attrs(function (_ref4) {
  var theme = _ref4.theme,
    _ref4$padding = _ref4.padding,
    padding = _ref4$padding === void 0 ? 'lg' : _ref4$padding,
    borderRadius = _ref4.borderRadius;
  return attachDataAttr('panel-footer')({
    padding: padding,
    borderRadius: borderRadius || "0  0 ".concat(theme.borders.radius["default"], " ").concat(theme.borders.radius["default"])
  });
})(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteral([""])));
function hoverRules(_ref5) {
  var hoverable = _ref5.hoverable,
    theme = _ref5.theme,
    boxShadow = _ref5.boxShadow;
  return hoverable && css(["&:hover{box-shadow:", ";transition:all 250ms cubic-bezier(0.075,0.82,0.165,1);}"], boxShadow || theme.boxShadows.raised);
}
Panel.displayName = 'Panel';
Panel.Body.displayName = 'Panel.Body';
Panel.Header.displayName = 'Panel.Header';
Panel.Footer.displayName = 'Panel.Footer';
Panel.propTypes = _objectSpread$l(_objectSpread$l({}, Panel.propTypes), {}, {
  hoverable: PropTypes.bool
});

var _templateObject$i;
var Spanner = Slate.div.attrs(function (_ref) {
  var _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? 'md' : _ref$padding,
    _ref$border = _ref.border,
    border = _ref$border === void 0 ? 'none' : _ref$border,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? 'none' : _ref$borderRadius;
  return attachDataAttr('spanner')({
    border: border,
    borderRadius: borderRadius,
    padding: padding
  });
})(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n"])));
Spanner.displayName = 'Spanner';

var index$1 = createGlobalStyle(["/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */ html{line-height:1.15;-webkit-text-size-adjust:100%;}body{margin:0;}main{display:block;}h1{font-size:2em;margin:0.67em 0;}hr{box-sizing:content-box;height:0;overflow:visible;}pre{font-family:monospace,monospace;font-size:1em;}a{background-color:transparent;}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted;}b,strong{font-weight:bolder;}code,kbd,samp{font-family:monospace,monospace;font-size:1em;}small{font-size:80%;}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline;}sub{bottom:-0.25em;}sup{top:-0.5em;}img{border-style:none;}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0;}button,input{overflow:visible;}button,select{text-transform:none;}button,[type=\"button\"],[type=\"reset\"],[type=\"submit\"]{-webkit-appearance:button;}button::-moz-focus-inner,[type=\"button\"]::-moz-focus-inner,[type=\"reset\"]::-moz-focus-inner,[type=\"submit\"]::-moz-focus-inner{border-style:none;padding:0;}button:-moz-focusring,[type=\"button\"]:-moz-focusring,[type=\"reset\"]:-moz-focusring,[type=\"submit\"]:-moz-focusring{outline:1px dotted ButtonText;}fieldset{padding:0.35em 0.75em 0.625em;}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal;}progress{vertical-align:baseline;}textarea{overflow:auto;}[type=\"checkbox\"],[type=\"radio\"]{box-sizing:border-box;padding:0;}[type=\"number\"]::-webkit-inner-spin-button,[type=\"number\"]::-webkit-outer-spin-button{height:auto;}[type=\"search\"]{-webkit-appearance:textfield;outline-offset:-2px;}[type=\"search\"]::-webkit-search-decoration{-webkit-appearance:none;}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit;}details{display:block;}summary{display:list-item;}template{display:none;}[hidden]{display:none;}"]);

var index = createGlobalStyle(["html,body{-webkit-overflow-scrolling:touch !important;overscroll-behavior:contain;height:100% !important;}html{overflow:auto !important;}body{font-family:", ";font-size:", ";color:", ";background-color:", "}*{box-sizing:border-box;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.globals.fontFamily;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.globals.baseFontSize;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.body;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.bodyBg;
});

/**
 * Simple single column layout
 * Row 1 is reserved for the header/nav
 * Row 2 is where the main content is displayed
 * Row 3 is reserved for the footer
 */

// const FULL_SPAN = ['1', '1', '1/4'];
var FULL_SPAN = '1';
var getStoreLayout = function getStoreLayout(theme) {
  return {
    // gridColumns: [
    // 	'1fr',
    // 	'1fr',
    // 	`minmax(0, 2fr) minmax(${theme.breakpoints[2] - 1}px, 2fr) minmax(0, 2fr)`,
    // 	`minmax(0, 2fr) minmax(${theme.breakpoints[3] - 1}px, 2fr) minmax(0, 2fr)`,
    // ],
    gridColumns: '1fr',
    gridRows: 'auto minmax(90vh, 1fr) auto'
  };
};
var getStoreHeader = function getStoreHeader() {
  return {
    gridRow: '1',
    gridColumn: FULL_SPAN
  };
};
var getStoreMain = function getStoreMain() {
  return {
    // gridColumn: ['1', '1', '2'],
    gridColumn: '1',
    elMaxWidth: '100vw'
  };
};
var getStoreFooter = function getStoreFooter() {
  return {
    gridColumn: FULL_SPAN
  };
};

/**
 * 2 column layout
 * Row 1 is reserved for the header/nav
 * Row 2 is where the main content is displayed
 * Row 3 is reserved for the footer
 */
var getAdminLayout = function getAdminLayout(theme) {
  return {
    // gridColumns: [
    // 	'1fr',
    // 	'1fr',
    // 	`minmax(0, 2fr) minmax(${theme.breakpoints[2] - 1}px, 2fr) minmax(0, 2fr)`,
    // 	`minmax(0, 2fr) minmax(${theme.breakpoints[3] - 1}px, 2fr) minmax(0, 2fr)`,
    // ],
    gridColumns: 'auto 12fr',
    gridRows: 'auto minmax(90vh, 1fr) auto'
  };
};
var getAdminHeader = function getAdminHeader() {
  return {
    gridRow: '1',
    gridColumn: '2'
  };
};
var getAdminMain = function getAdminMain() {
  return {
    // gridColumn: ['1', '1', '2'],
    gridColumn: '2',
    elMaxWidth: '100vw'
  };
};
var getAdminFooter = function getAdminFooter() {
  return {
    gridColumn: '2'
  };
};
var getAdminNavBar = function getAdminNavBar() {
  return {
    gridColumn: '1',
    gridRow: '1 / -1'
  };
};

var _templateObject$h, _templateObject2$6, _templateObject3$5, _templateObject4$5, _templateObject5$3, _templateObject6$1;
function ownKeys$k(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$k(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$k(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$k(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/**
 * @hack not sure if handling presets like this is a good idea.. but the result api is nice.
 * @reason didn't see a clean way of using hooks to provide the preset to the other components.
 * the other way is to pass the preset to the nested components but that's a bit cumbersome
 */
var PRESET = undefined;
var GridLayout = Slate.div.attrs(function (props) {
  return _objectSpread$k({
    grid: true
  }, determinePresetProps(props));
})(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral([""])));

/** the prevent clicks is just a temporary solution.  we need to figure out why the header is so large */
GridLayout.Header = Slate.header.attrs(function (props) {
  return _objectSpread$k({}, determinePresetHeader());
})(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n\t/* pointer-events: none;*/\n"])));
GridLayout.Header.displayName = 'GridLayout.Header';
GridLayout.Main = Slate.main.attrs(function (props) {
  return _objectSpread$k({}, determinePresetMain());
})(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral([""])));
GridLayout.Main.displayName = 'GridLayout.Main';
GridLayout.Footer = Slate.footer.attrs(function (props) {
  return _objectSpread$k({}, determinePresetFooter());
})(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral([""])));
GridLayout.Footer.displayName = 'GridLayout.Footer';
GridLayout.Spanner = Slate.div.attrs(function (props) {
  return _objectSpread$k({}, determinePresetSpanner());
})(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral([""])));
GridLayout.Spanner.displayName = 'GridLayout.Spanner';
GridLayout.Nav = Slate.div.attrs(function (props) {
  return _objectSpread$k(_objectSpread$k({}, determinePresetNav()), props);
})(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral([""])));
GridLayout.Nav.displayName = 'GridLayout.Nav';

/**
 * @todo add presets for grid
 * @todo add presets for admin
 */
var determinePresetProps = function determinePresetProps(_ref) {
  var preset = _ref.preset;
    _ref.theme;
  PRESET = preset;
  switch (preset) {
    case 'store':
      return getStoreLayout();
    case 'admin':
      return getAdminLayout();
    default:
      return {};
  }
};

/**
 * @todo add presets for grid
 * @todo add presets for admin
 */
var determinePresetHeader = function determinePresetHeader() {
  switch (PRESET) {
    case 'store':
      return getStoreHeader();
    case 'admin':
      return getAdminHeader();
    default:
      return {};
  }
};

/**
 * @todo add presets for grid
 * @todo add presets for admin
 */
var determinePresetMain = function determinePresetMain() {
  switch (PRESET) {
    case 'store':
      return getStoreMain();
    case 'admin':
      return getAdminMain();
    default:
      return {};
  }
};

/**
 * @todo add presets for grid
 * @todo add presets for admin
 */
var determinePresetFooter = function determinePresetFooter() {
  switch (PRESET) {
    case 'store':
      return getStoreFooter();
    case 'admin':
      return getAdminFooter();
    default:
      return {};
  }
};

/**
 * @todo add presets for grid
 * @todo add presets for admin
 */
var determinePresetSpanner = function determinePresetSpanner() {
  switch (PRESET) {
    case 'store':
      return getStoreFooter();
    case 'admin':
      return getAdminFooter();
    default:
      return {};
  }
};

/**
 * @todo add presets for grid
 * @todo add presets for admin
 */
var determinePresetNav = function determinePresetNav() {
  switch (PRESET) {
    case 'admin':
      return getAdminNavBar();
    default:
      return {};
  }
};
GridLayout.displayName = 'GridLayout';
GridLayout.propTypes = _objectSpread$k(_objectSpread$k({}, GridLayout.propTypes), {}, {
  preset: PropTypes.oneOf(['store', 'admin', 'list', 'grid'])
});

var _templateObject$g;
function ownKeys$j(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$j(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$j(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$j(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Button = Slate.button.attrs(function (_ref) {
  var _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$border = _ref.border,
    border = _ref$border === void 0 ? 'default' : _ref$border,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? 'default' : _ref$borderRadius,
    _ref$borderColor = _ref.borderColor,
    borderColor = _ref$borderColor === void 0 ? 'transparent' : _ref$borderColor,
    _ref$shadow = _ref.shadow,
    shadow = _ref$shadow === void 0 ? 'default' : _ref$shadow,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? 'inline-block' : _ref$display,
    _ref$hoverShadow = _ref.hoverShadow,
    hoverShadow = _ref$hoverShadow === void 0 ? 'raised' : _ref$hoverShadow,
    _ref$typoWeight = _ref.typoWeight,
    typoWeight = _ref$typoWeight === void 0 ? '500' : _ref$typoWeight,
    padding = _ref.padding,
    theme = _ref.theme;
  return attachDataAttr('button')({
    disabled: disabled,
    border: border,
    borderRadius: borderRadius,
    borderColor: borderColor,
    shadow: shadow,
    display: display,
    hoverShadow: hoverShadow,
    typoWeight: typoWeight,
    padding: padding || "".concat(theme.globals.baseFactor * 1.5, "px ").concat(theme.globals.baseFactor * 3, "px")
  });
})(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n\t", "\n\n"])), function (_ref2) {
  var disabled = _ref2.disabled,
    hoverColor = _ref2.hoverColor,
    hoverShadow = _ref2.hoverShadow,
    theme = _ref2.theme;
  return css(["opacity:1;transition:color 250ms linear,background-color 250ms linear,box-shadow 250ms ease,transform 250ms ease,opacity 250ms ease;&:hover{", "}&:disabled{background-color:", ";color:", ";box-shadow:none;transition:color 250ms linear,background-color 250ms linear,box-shadow 250ms ease;}&:active{box-shadow:none;transform:scale(0.95);transition:transform 250ms ease,box-shadow 250ms ease;}"], disabled ? css(["cursor:not-allowed;background-color:", ";color:", ";"], theme.colors.ambient, theme.colors.body) : css(["background-color:", ";cursor:pointer;box-shadow:", ";opacity:0.75;"], theme.colors[hoverColor], theme.boxShadows[hoverShadow]), theme.colors.ambient, theme.colors.ambientDark);
});
Button.displayName = 'Button';
Button.propTypes = _objectSpread$j(_objectSpread$j({}, Button.propTypes), {}, {
  hoverColor: Button.propTypes.backgroundColor,
  hoverShadow: Button.propTypes.shadow
});

var _templateObject$f, _templateObject2$5, _templateObject3$4, _templateObject4$4, _templateObject5$2;
function ownKeys$i(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$i(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$i(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$i(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var extraHeroStyles = function extraHeroStyles(_ref) {
  var theme = _ref.theme;
  return css(["overflow:hidden;background-size:cover;background-position:50% 50%;@media (min-width:", "px){background-attachment:fixed;}"], theme.breakpoints[1]);
};
var Hero = Slate.div.attrs(function (props) {
  return attachDataAttr('hero')({
    elHeight: props.elHeight || '45vh',
    backgroundColor: props.backgroundColor || 'accent',
    backgroundGradientColor: props.backgroundGradientColor || props.image ? "to bottom, black 0%, rgba(0, 0, 0, 0.738) 19%, rgba(0, 0, 0, 0.541) 34%, rgba(0, 0, 0, 0.382) 47%, rgba(0, 0, 0, 0.278) 56.5%, rgba(0, 0, 0, 0.194) 65%, rgba(0, 0, 0, 0.126) 73%, rgba(0, 0, 0, 0.075) 80.2%, rgba(0, 0, 0, 0.042) 86.1%, rgba(0, 0, 0, 0.021) 91%, rgba(0, 0, 0, 0.008) 95.2%, rgba(0, 0, 0, 0.002) 98.2%, transparent 100%), url(".concat(props.image) : undefined,
    display: props.display || 'flex',
    flexDirection: props.flexDirection || 'column',
    position: 'relative'
  });
})(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n\t", "\n"])), extraHeroStyles);
Hero.Blur = styled.div.attrs(attachDataAttr('hero-blur')()).withConfig({
  displayName: "Hero__Blur",
  componentId: "sc-1nvtf2o-0"
})(["position:absolute;left:0;right:0;top:0;bottom:0;transform:scale(1.1);filter:blur(50px) brightness(50%);background-image:url(", ");", ";"], function (_ref2) {
  var image = _ref2.image;
  return image;
}, extraHeroStyles);

/** basically the same as a regular container except with some extra styles */
Hero.Container = Slate.div.attrs(function (_ref3) {
  var _ref3$elWidth = _ref3.elWidth,
    elWidth = _ref3$elWidth === void 0 ? ['100%'] : _ref3$elWidth,
    _ref3$flexGrow = _ref3.flexGrow,
    flexGrow = _ref3$flexGrow === void 0 ? '1' : _ref3$flexGrow;
    _ref3.image;
    var _ref3$margin = _ref3.margin,
    margin = _ref3$margin === void 0 ? 'auto' : _ref3$margin,
    _ref3$padding = _ref3.padding,
    padding = _ref3$padding === void 0 ? ['md', 'xlg'] : _ref3$padding,
    _ref3$zIndex = _ref3.zIndex,
    zIndex = _ref3$zIndex === void 0 ? '0' : _ref3$zIndex,
    elMaxWidth = _ref3.elMaxWidth,
    theme = _ref3.theme;
  return attachDataAttr('hero-container')({
    elMaxWidth: elMaxWidth || ['100vw', "".concat(theme.breakpoints[4], "px")],
    elWidth: elWidth,
    flexGrow: flexGrow,
    margin: margin,
    padding: padding,
    zIndex: zIndex
  });
})(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n\t/** using this instead of backgroundGradientColor prop because it didn't want to work here*/\n\t", "\n\t", "\n"])), function (_ref4) {
  var image = _ref4.image;
  return image && css(["background-image:linear-gradient( to bottom,black 0%,rgba(0,0,0,0.738) 19%,rgba(0,0,0,0.541) 34%,rgba(0,0,0,0.382) 47%,rgba(0,0,0,0.278) 56.5%,rgba(0,0,0,0.194) 65%,rgba(0,0,0,0.126) 73%,rgba(0,0,0,0.075) 80.2%,rgba(0,0,0,0.042) 86.1%,rgba(0,0,0,0.021) 91%,rgba(0,0,0,0.008) 95.2%,rgba(0,0,0,0.002) 98.2%,transparent 100% ),url(", ");"], image);
}, extraHeroStyles);
Hero.Title = Slate.span.attrs(function (props) {
  return attachDataAttr('hero-title')({
    display: 'block',
    typoSize: props.typoSize || ['lg'],
    typoWeight: props.typoWeight || 'strong',
    textColor: props.textColor || 'bodyInverse',
    paddingTop: 'sm'
  });
})(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral([""])));
Hero.Subtitle = Slate.span.attrs(function (props) {
  return attachDataAttr('hero-subtitle')({
    display: 'block',
    typoSize: props.typoSize || ['lg'],
    typoWeight: props.typoWeight || 'light',
    textColor: props.textColor || 'bodyInverse',
    paddingTop: 'sm'
  });
})(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral([""])));
Hero.Small = Slate.small.attrs(function (props) {
  return attachDataAttr('hero-small')({
    typoSize: props.typoSize || ['md'],
    textColor: props.textColor || 'bodyInverse',
    paddingTop: 'sm'
  });
})(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral([""])));
Hero.displayName = 'Hero';
Hero.propTypes = _objectSpread$i(_objectSpread$i({}, Hero.propTypes), {}, {
  image: PropTypes.string
});

var _templateObject$e, _templateObject2$4, _templateObject3$3, _templateObject4$3;
var Navbar = Slate.nav.attrs(function (props) {
  return attachDataAttr('navbar')({
    grid: true,
    gridColumns: 'repeat(3, 1fr)',
    alignItems: 'center',
    padding: props.padding || 'md',
    backgroundColor: props.backgroundColor || 'brand',
    textColor: 'bodyInverse'
  });
})(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n\toverflow: hidden;\n"])));
Navbar.Logo = Slate.img.attrs(function (props) {
  return attachDataAttr('navbar-logo')({
    gridColumn: 1
  });
})(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n\tmax-height: ", ";\n\t/* fallback for grid */\n\torder: -1;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing.lg;
});
Navbar.Center = Slate.span.attrs(function (props) {
  return attachDataAttr('navbar-center')({
    typoSize: 'md',
    display: ['none', 'inline-block'],
    gridColumn: 2,
    textAlign: 'center'
  });
})(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n\t/* fallback for grid */\n\torder: 0;\n"])));
Navbar.Actions = Slate.div.attrs(function (props) {
  return attachDataAttr('navbar-actions')({
    gridColumn: 3,
    textAlign: 'center'
  });
})(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["\n\t/* fallback for grid */\n\torder: 1;\n"])));
Navbar.displayName = 'Navbar';

var _templateObject$d;
function ownKeys$h(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$h(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$h(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$h(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Container = Slate.div.attrs(function (_ref) {
  var _ref$margin = _ref.margin,
    margin = _ref$margin === void 0 ? 'auto' : _ref$margin,
    _ref$elWidth = _ref.elWidth,
    elWidth = _ref$elWidth === void 0 ? ['100%', '90%'] : _ref$elWidth,
    elMaxWidth = _ref.elMaxWidth,
    theme = _ref.theme;
  return attachDataAttr('container')({
    margin: margin,
    elWidth: elWidth,
    elMaxWidth: elMaxWidth ? elMaxWidth : ['100vw', "".concat(theme.breakpoints[3] - 1, "px")]
  });
})(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral([""])));
Container.displayName = 'Container';
Container.propTypes = _objectSpread$h({}, Container.propTypes);

var _templateObject$c, _templateObject2$3, _templateObject3$2, _templateObject4$2;
function ownKeys$g(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$g(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$g(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$g(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/**
 * @todo find a way to better extend the Panel Component
 */
var MediaCard = styled(Panel).attrs(function (_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? 'bodyInverse' : _ref$backgroundColor,
    _ref$marginBottom = _ref.marginBottom,
    marginBottom = _ref$marginBottom === void 0 ? 'md' : _ref$marginBottom,
    _ref$gridItem = _ref.gridItem,
    gridItem = _ref$gridItem === void 0 ? false : _ref$gridItem,
    theme = _ref.theme;
  return attachDataAttr('media_card')({
    backgroundColor: backgroundColor,
    marginBottom: marginBottom,
    padding: 'none',
    shadow: 'default',
    grid: true,
    gridColumns: gridItem ? '1fr' : '1fr 2fr',
    gridRows: '1fr',
    elHeight: gridItem ? 'auto' : ["".concat(theme.baseUnit * 16, "px"), "".concat(theme.baseUnit * 20, "px")]
  });
}).withConfig({
  displayName: "MediaCard",
  componentId: "sc-1olvr7p-0"
})(["overflow:hidden;"]);
MediaCard.Content = Slate.div.attrs(function (_ref2) {
  var theme = _ref2.theme;
  return attachDataAttr('media_card-content')({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'relative',
    padding: ['md', "".concat(theme.baseUnit * 4, "px")],
    gridColumn: ['span 1']
  });
})(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n\toverflow: hidden;\n"])));
MediaCard.Title = styled(H3).attrs(function (_ref3) {
  var margin = _ref3.margin,
    theme = _ref3.theme;
  return attachDataAttr('media_card-title')({
    margin: margin || ['none', "0 0 ".concat(theme.baseUnit, "px 0")]
  });
}).withConfig({
  displayName: "MediaCard__Title",
  componentId: "sc-1olvr7p-1"
})([""]);
MediaCard.Actions = Slate.div.attrs(function (props) {
  return attachDataAttr('media_card-actions')({});
})(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral([""])));
MediaCard.Subtitle = styled(P).attrs(function (_ref4) {
  var margin = _ref4.margin,
    theme = _ref4.theme;
  return attachDataAttr('media_card-subtitle')({
    margin: margin || ["".concat(theme.baseUnit * 2, "px 0"), 'none']
  });
}).withConfig({
  displayName: "MediaCard__Subtitle",
  componentId: "sc-1olvr7p-2"
})([""]);
MediaCard.ImageContainer = Slate.div.attrs(function (props) {
  return attachDataAttr('media_card-image_container')({
    gridColumn: 'span 1',
    position: 'relative'
  });
})(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n\toverflow: hidden;\n"])));
MediaCard.Image = Slate.img.attrs(function (props) {
  return attachDataAttr('media_card-image')({});
})(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n\tmin-height: 100%;\n\twidth: 100%;\n"])));
MediaCard.displayName = 'MediaCard';
MediaCard.propTypes = _objectSpread$g({}, MediaCard.propTypes);

var _templateObject$b;
function ownKeys$f(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$f(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$f(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$f(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Tag = Slate.span.attrs(function (_ref) {
  var theme = _ref.theme,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? 'bodyInverse' : _ref$backgroundColor,
    _ref$borderColor = _ref.borderColor,
    borderColor = _ref$borderColor === void 0 ? 'ambientDark' : _ref$borderColor,
    padding = _ref.padding;
  return attachDataAttr('tag')({
    backgroundColor: backgroundColor,
    borderColor: borderColor,
    display: 'inline-block',
    border: 'default',
    borderRadius: 'default',
    padding: padding || ["".concat(theme.globals.baseFactor * 0.75, "px ").concat(theme.globals.baseFactor * 1.25, "px"), "".concat(theme.globals.baseFactor, "px ").concat(theme.globals.baseFactor * 2, "px")]
  });
})(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n\t/** @todo: extra styles here */\n"])));
Tag.displayName = 'Tag';
Tag.propTypes = _objectSpread$f({}, Tag.propTypes);

var _excluded$d = ["marginBottom"];
var _templateObject$a, _templateObject2$2;
function ownKeys$e(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$e(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$e(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$e(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var bullets = function bullets(_ref) {
  var bullets = _ref.bullets;
  return bullets && css(["list-style:", ";"], bullets);
};
var List = Slate.ul.attrs(function (_ref2) {
  var bullets = _ref2.bullets;
  return attachDataAttr('list')(bullets === 'none' ? {
    margin: 'none',
    padding: 'none'
  } : {});
})(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n\t", ";\n"])), bullets);
List.Item = Slate.li.attrs(function (_ref3) {
  var _ref3$marginBottom = _ref3.marginBottom,
    marginBottom = _ref3$marginBottom === void 0 ? 'md' : _ref3$marginBottom,
    props = _objectWithoutProperties(_ref3, _excluded$d);
  return attachDataAttr('list-item')(_objectSpread$e({
    padding: 'none',
    marginBottom: marginBottom
  }, props));
})(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral([""])));
List.displayName = 'List';
List.propTypes = _objectSpread$e({
  /* Controls the list-style property of the list */
  bullets: PropTypes.string
}, List.propTypes);

var _templateObject$9;
function ownKeys$d(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$d(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$d(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$d(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Input = Slate.input.attrs(function (_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    _ref$border = _ref.border,
    border = _ref$border === void 0 ? 'default' : _ref$border,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? 'default' : _ref$borderRadius,
    _ref$borderColor = _ref.borderColor,
    borderColor = _ref$borderColor === void 0 ? 'ambientDark' : _ref$borderColor,
    padding = _ref.padding,
    theme = _ref.theme;
  return attachDataAttr('input')({
    type: type,
    border: border,
    borderRadius: borderRadius,
    borderColor: borderColor,
    padding: padding || "".concat(theme.globals.baseFactor, "px ").concat(theme.globals.baseFactor * 2, "px")
  });
})(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n\tappearance: none;\n\t&:focus {\n\t\toutline: ", ";\n\t\tborder-color: ", ";\n\t\tborder-width: 2px;\n\t}\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.accent;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.accent;
});
Input.displayName = 'Input';
Input.propTypes = _objectSpread$d({}, Input.propTypes);

var _templateObject$8, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1;
function ownKeys$c(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$c(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$c(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$c(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var InputGroup = Slate.label.attrs(function (_ref) {
  var _ref$display = _ref.display,
    display = _ref$display === void 0 ? 'inline-block' : _ref$display;
  return attachDataAttr('input_group')({
    display: display
  });
})(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n\tcursor: pointer;\n"])));
InputGroup.Icon = Slate.span.attrs(function (_ref2) {
  var _ref2$backgroundColor = _ref2.backgroundColor,
    backgroundColor = _ref2$backgroundColor === void 0 ? 'transparent' : _ref2$backgroundColor,
    theme = _ref2.theme;
  return attachDataAttr('input_group-icon')({
    backgroundColor: backgroundColor,
    display: 'inline-flex',
    alignItems: 'center',
    padding: 'sm',
    zIndex: '1',
    order: '-1',
    borderRadius: "".concat(theme.borders.radius["default"], " 0 0 ").concat(theme.borders.radius["default"])
  });
})(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral([""])));
InputGroup.Fields = Slate.div.attrs(function (_ref3) {
  var _ref3$border = _ref3.border,
    border = _ref3$border === void 0 ? 'default' : _ref3$border,
    _ref3$borderRadius = _ref3.borderRadius,
    borderRadius = _ref3$borderRadius === void 0 ? 'default' : _ref3$borderRadius,
    _ref3$borderColor = _ref3.borderColor,
    borderColor = _ref3$borderColor === void 0 ? 'ambientDark' : _ref3$borderColor,
    _ref3$backgroundColor = _ref3.backgroundColor,
    backgroundColor = _ref3$backgroundColor === void 0 ? 'ambientLight' : _ref3$backgroundColor,
    _ref3$display = _ref3.display,
    display = _ref3$display === void 0 ? 'flex' : _ref3$display,
    _ref3$shadow = _ref3.shadow,
    shadow = _ref3$shadow === void 0 ? 'none' : _ref3$shadow;
  return attachDataAttr('input_group-fields')({
    border: border,
    borderRadius: borderRadius,
    borderColor: borderColor,
    backgroundColor: backgroundColor,
    display: display,
    shadow: shadow
  });
})(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n\toverflow: ", ";\n\ttransition: background-color 250ms cubic-bezier(0.075, 0.82, 0.165, 1), box-shadow 350ms cubic-bezier(0.075, 0.82, 0.165, 1), color 250ms cubic-bezier(0.075, 0.82, 0.165, 1);\n\t&:focus-within {\n\t\ttransition: background-color 250ms cubic-bezier(0.075, 0.82, 0.165, 1), box-shadow 350ms cubic-bezier(0.075, 0.82, 0.165, 1), color 250ms cubic-bezier(0.075, 0.82, 0.165, 1);\n\t\t", "\n\n\t\t", " {\n\t\t\t", "\n\t\t}\n\t}\n"])), function (props) {
  return props.overflow || 'hidden';
}, function (_ref4) {
  var theme = _ref4.theme;
  return css(["border-color:", ";box-shadow:", ";"], theme.colors.accent, theme.boxShadows.raised);
}, InputGroup.Icon, function (_ref5) {
  var theme = _ref5.theme;
  return css(["color:", ";"], theme.colors.accent);
});
InputGroup.Input = styled(Input).attrs(function (_ref6) {
  var _ref6$backgroundColor = _ref6.backgroundColor,
    backgroundColor = _ref6$backgroundColor === void 0 ? 'transparent' : _ref6$backgroundColor,
    _ref6$paddingLeft = _ref6.paddingLeft,
    paddingLeft = _ref6$paddingLeft === void 0 ? 'none' : _ref6$paddingLeft,
    _ref6$flexGrow = _ref6.flexGrow,
    flexGrow = _ref6$flexGrow === void 0 ? 1 : _ref6$flexGrow;
  return {
    backgroundColor: backgroundColor,
    flexGrow: flexGrow,
    paddingLeft: paddingLeft,
    border: 'none',
    borderRadius: 'none',
    order: '0'
  };
}).withConfig({
  displayName: "InputGroup__Input",
  componentId: "sc-1k93jkz-0"
})([""]);
InputGroup.Label = Slate.span.attrs(function (_ref7) {
  var _ref7$display = _ref7.display,
    display = _ref7$display === void 0 ? 'block' : _ref7$display,
    padding = _ref7.padding,
    theme = _ref7.theme;
  return attachDataAttr('input_group-label')({
    display: display,
    padding: padding || "".concat(theme.spacing.sm, " 0")
  });
})(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n"])));
InputGroup.Actions = Slate.div.attrs(function (_ref8) {
  var _ref8$backgroundColor = _ref8.backgroundColor,
    backgroundColor = _ref8$backgroundColor === void 0 ? 'transparent' : _ref8$backgroundColor;
  return attachDataAttr('input_group-actions')({
    backgroundColor: backgroundColor,
    order: '1'
  });
})(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral([""])));
InputGroup.Action = styled(Button).attrs(function (_ref9) {
  var _ref9$type = _ref9.type,
    type = _ref9$type === void 0 ? 'submit' : _ref9$type,
    _ref9$textColor = _ref9.textColor,
    textColor = _ref9$textColor === void 0 ? 'accent' : _ref9$textColor,
    _ref9$backgroundColor = _ref9.backgroundColor,
    backgroundColor = _ref9$backgroundColor === void 0 ? 'transparent' : _ref9$backgroundColor,
    _ref9$border = _ref9.border,
    border = _ref9$border === void 0 ? 'none' : _ref9$border,
    _ref9$borderTopLeftRa = _ref9.borderTopLeftRadius,
    borderTopLeftRadius = _ref9$borderTopLeftRa === void 0 ? 'none' : _ref9$borderTopLeftRa,
    _ref9$borderBottomLef = _ref9.borderBottomLeftRadius,
    borderBottomLeftRadius = _ref9$borderBottomLef === void 0 ? 'none' : _ref9$borderBottomLef,
    _ref9$hoverShadow = _ref9.hoverShadow,
    hoverShadow = _ref9$hoverShadow === void 0 ? 'none' : _ref9$hoverShadow,
    _ref9$shadow = _ref9.shadow,
    shadow = _ref9$shadow === void 0 ? 'none' : _ref9$shadow,
    _ref9$zIndex = _ref9.zIndex,
    zIndex = _ref9$zIndex === void 0 ? '1' : _ref9$zIndex,
    padding = _ref9.padding,
    theme = _ref9.theme;
  return attachDataAttr('input_group-action')({
    padding: padding || "".concat(theme.spacing.sm, " ").concat(theme.spacing.md),
    type: type,
    textColor: textColor,
    backgroundColor: backgroundColor,
    border: border,
    borderTopLeftRadius: borderTopLeftRadius,
    borderBottomLeftRadius: borderBottomLeftRadius,
    hoverShadow: hoverShadow,
    shadow: shadow,
    zIndex: zIndex
  });
}).withConfig({
  displayName: "InputGroup__Action",
  componentId: "sc-1k93jkz-1"
})([""]);
InputGroup.displayName = 'InputGroup';
InputGroup.propTypes = _objectSpread$c({}, InputGroup.propTypes);

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var _excluded$c = ["boxSizing", "marginBottom"];
function ownKeys$b(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$b(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$b(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$b(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Select = function Select(props) {
  var theme = useContext(ThemeContext);
  var styles = makeThemeStyles(theme, props);
  return /*#__PURE__*/React.createElement(ReactSelect, _extends({
    styles: styles
  }, props));
};
var makeThemeStyles = function makeThemeStyles(theme, _ref) {
  var border = _ref.border,
    boxShadows = _ref.boxShadows;
    _ref.padding;
  return {
    control: function control(provided, _ref2) {
      var isFocused = _ref2.isFocused;
      return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        border: border || "1px solid ".concat(isFocused ? theme.colors.accent : theme.colors.ambientDark),
        borderRadius: "".concat(theme.borders.radius["default"]),
        boxShadow: isFocused && (boxShadows || theme.boxShadows.raised),
        transition: "box-shadow 350ms cubic-bezier(0.075, 0.82, 0.165, 1)",
        backgroundColor: theme.colors.ambientLight,
        padding: "".concat(theme.globals.baseFactor, "px ").concat(theme.globals.baseFactor * 0.5, "px ").concat(theme.globals.baseFactor, "px ").concat(theme.spacing.md)
      };
    },
    valueContainer: function valueContainer(provided, _ref3) {
      _ref3.isFocused;
      return _objectSpread$b(_objectSpread$b({}, provided), {}, {
        padding: 0,
        width: '100%'
      });
    },
    dropdownIndicator: function dropdownIndicator(provided, _ref4) {
      _ref4.isFocused;
      return _objectSpread$b(_objectSpread$b({}, provided), {}, {
        padding: "0 ".concat(theme.spacing.sm)
      });
    },
    singleValue: function singleValue(provided) {
      return _objectSpread$b({}, provided);
    },
    menu: function menu(_ref5, _ref6) {
      _ref5.boxSizing;
        _ref5.marginBottom;
        var styles = _objectWithoutProperties(_ref5, _excluded$c);
      var isFocused = _ref6.isFocused;
      return _objectSpread$b(_objectSpread$b({}, styles), {}, {
        border: "1px solid ".concat(isFocused ? theme.colors.accent : theme.colors.ambientDark),
        borderRadius: "".concat(theme.borders.radius["default"]),
        boxShadow: theme.boxShadows.raised,
        marginTop: "".concat(theme.spacing.md),
        overflow: 'hidden'
      });
    },
    option: function option(provided, _ref7) {
      var isSelected = _ref7.isSelected,
        isFocused = _ref7.isFocused;
      return {
        ':active': {
          backgroundColor: theme.colors.accentLight
        },
        ':hover': {
          backgroundColor: theme.colors.accentLight
        },
        padding: "".concat(theme.spacing.sm, " ").concat(theme.spacing.md),
        backgroundColor: isSelected || isFocused ? theme.colors.accentLight : theme.colors.transparent
      };
    },
    placeholder: function placeholder(provided, state) {
      return _objectSpread$b(_objectSpread$b({}, provided), {}, {
        color: theme.colors.body
      });
    }
  };
};
Select.displayName = 'Select';
// Select.propTypes = {
// 	...Select.propTypes,
// 	/** @todo: more props here */
// };
/**
 * just making it easy for now.  we should not be exporting the select component will all these components attached
 */
Select.Components = components;

var _templateObject$7;
function ownKeys$a(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$a(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$a(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$a(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Div = Slate.div.attrs(attachDataAttr('div')())(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral([""])));
Div.displayName = 'Div';
Div.propTypes = _objectSpread$a({}, Div.propTypes);

var _excluded$b = ["elWidth"];
var _templateObject$6;
function ownKeys$9(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$9(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$9(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$9(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Img = Slate.img.attrs(function (_ref) {
  var _ref$elWidth = _ref.elWidth,
    elWidth = _ref$elWidth === void 0 ? '100%' : _ref$elWidth,
    props = _objectWithoutProperties(_ref, _excluded$b);
  return attachDataAttr('img')(_objectSpread$9({
    elWidth: elWidth
  }, props));
})(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n"])));
Img.displayName = 'Img';
Img.propTypes = _objectSpread$9({}, Img.propTypes);

var _excluded$a = ["src"];
function ownKeys$8(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$8(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$8(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$8(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/**
 * @todo: once createResource is stable, use that instead of this janky state
 */
var loaded$1 = false;
var getImage = function getImage(src) {
  var req = new XMLHttpRequest();
  throw new Promise(function (resolve, reject) {
    req.onreadystatechange = function () {
      if (req.readyState !== 4) return;

      // Process the response
      if (req.status >= 200 && req.status < 400) {
        // If successful
        loaded$1 = true;
        resolve(req);
      } else {
        // If failed
        reject({
          status: req.status,
          statusText: req.statusText
        });
      }
    };
    req.open('GET', src, true);
    req.send();
  });
};
var SuspensefulImg = function SuspensefulImg(_ref) {
  var src = _ref.src,
    props = _objectWithoutProperties(_ref, _excluded$a);
  if (!loaded$1) {
    getImage(src);
  }
  return /*#__PURE__*/React.createElement(Img, _extends({
    src: src
  }, props));
};
SuspensefulImg.displayName = 'SuspensefulImg';
SuspensefulImg.propTypes = _objectSpread$8({}, SuspensefulImg.propTypes);

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

var _templateObject$5;
function ownKeys$7(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$7(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$7(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$7(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SlateModal = Modal.styled(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n\t", ";\n\t", ";\n"])), css.apply(void 0, _toConsumableArray(coreAnatomy.rules)), css.apply(void 0, _toConsumableArray(helperAnatomy.rules)));
SlateModal.displayName = 'Modal';
SlateModal.propTypes = _objectSpread$7({}, SlateModal.propTypes);
SlateModal.defaultProps = attachDataAttr('modal')();

var _templateObject$4;
function ownKeys$6(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$6(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$6(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$6(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ModalBackground = Slate.div.attrs(function (_ref) {
  var _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'fixed' : _ref$position,
    _ref$positionTop = _ref.positionTop,
    positionTop = _ref$positionTop === void 0 ? '0' : _ref$positionTop,
    _ref$positionLeft = _ref.positionLeft,
    positionLeft = _ref$positionLeft === void 0 ? '0' : _ref$positionLeft,
    _ref$elWidth = _ref.elWidth,
    elWidth = _ref$elWidth === void 0 ? '100vw' : _ref$elWidth,
    _ref$elHeight = _ref.elHeight,
    elHeight = _ref$elHeight === void 0 ? '100vh' : _ref$elHeight,
    _ref$zIndex = _ref.zIndex,
    zIndex = _ref$zIndex === void 0 ? '9999' : _ref$zIndex,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? 'rgba(0,0,0, .75)' : _ref$backgroundColor,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? 'flex' : _ref$display,
    _ref$alignItems = _ref.alignItems,
    alignItems = _ref$alignItems === void 0 ? 'center' : _ref$alignItems,
    _ref$justifyContent = _ref.justifyContent,
    justifyContent = _ref$justifyContent === void 0 ? 'center' : _ref$justifyContent,
    _ref$blur = _ref.blur,
    blur = _ref$blur === void 0 ? '5px' : _ref$blur,
    open = _ref.open;
  return attachDataAttr('modal-background')({
    position: position,
    positionTop: positionTop,
    positionLeft: positionLeft,
    elWidth: elWidth,
    elHeight: elHeight,
    zIndex: zIndex,
    backgroundColor: backgroundColor,
    display: display,
    alignItems: alignItems,
    justifyContent: justifyContent,
    blur: blur,
    open: open
  });
})(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n\topacity: ", ";\n\tbackdrop-filter: blur(", ") opacity(", ");\n\ttransition: opacity 250ms linear; \n"])), function (_ref2) {
  var open = _ref2.open;
  return open ? 1 : 0;
}, function (_ref3) {
  var blur = _ref3.blur;
  return blur;
}, function (_ref4) {
  var open = _ref4.open;
  return open ? 1 : 0;
});
ModalBackground.displayName = 'ModalBackground';
ModalBackground.propTypes = _objectSpread$6({}, ModalBackground.propTypes);

var _templateObject$3;
function ownKeys$5(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$5(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$5(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Thumbnail = Slate.img.attrs(function (_ref) {
  var _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? 'default' : _ref$borderRadius,
    _ref$elWidth = _ref.elWidth,
    elWidth = _ref$elWidth === void 0 ? '75px' : _ref$elWidth,
    _ref$elHeight = _ref.elHeight,
    elHeight = _ref$elHeight === void 0 ? '75px' : _ref$elHeight;
  return attachDataAttr('thumbnail')({
    borderRadius: borderRadius,
    elWidth: elWidth,
    elHeight: elHeight
  });
})(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n\t", "\n"])), thumbnailStyles);
function thumbnailStyles(_ref2) {
  var theme = _ref2.theme,
    interactive = _ref2.interactive;
  return css(["", " &:focus{outline-color:", ";}"], interactive && css(["transition:transform 250ms ease,box-shadow 250ms ease;&:hover{cursor:pointer;box-shadow:", ";transition:transform 250ms ease,box-shadow 250ms ease;}&:active{box-shadow:none;transform:scale(0.95);transition:transform 250ms ease,box-shadow 250ms ease;}"], theme.boxShadows.raised), theme.colors.accent);
}
Thumbnail.displayName = 'Thumbnail';
Thumbnail.propTypes = _objectSpread$5(_objectSpread$5({}, Thumbnail.propTypes), {}, {
  interactive: PropTypes.bool
});

var _excluded$9 = ["src", "onLoad", "onError"];

// const ScriptLoader = Slate.div.attrs(props => ({
// }))`
// 	/** @todo: extra styles here */
// `;

// ScriptLoader.displayName = 'ScriptLoader';
// ScriptLoader.propTypes = {
// 	...ScriptLoader.propTypes,
// 	/** @todo: more props here */
// };

// export default ScriptLoader;

/**
 * @todo: once createResource is stable, use that instead of this janky state
 */
var loaded = false;
var loading = false;
var ScriptLoader = function ScriptLoader(_ref) {
  var src = _ref.src,
    onLoad = _ref.onLoad,
    onError = _ref.onError;
    _objectWithoutProperties(_ref, _excluded$9);
  if (!loaded && !loading) {
    loading = true;
    throw new Promise(function (resolve, reject) {
      try {
        var script = document.createElement('script');
        document.body.appendChild(script);
        script.onload = function () {
          loaded = true;
          resolve(onLoad(loaded));
        };
        script.src = src;
      } catch (e) {
        loaded = true;
        onError(e);
        reject(e);
      } finally {
        loading = false;
      }
    });
  }
  return null;
};

var _templateObject$2;
function ownKeys$4(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getSizeProps = function getSizeProps(base, size) {
  switch (size) {
    case 'sm':
      {
        return {
          elHeight: "".concat(base * 2, "px"),
          padding: "0 ".concat(base / 1.5, "px"),
          typoSize: 'sm'
        };
      }
    case 'lg':
      {
        return {
          elHeight: "".concat(base * 4, "px"),
          padding: "0 ".concat(base * 3, "px"),
          typoSize: 'lg'
        };
      }
    default:
      {
        return {
          elHeight: "".concat(base * 3.5, "px"),
          padding: "0 ".concat(base * 2, "px"),
          typoSize: 'md'
        };
      }
  }
};
var Badge = Slate.div.attrs(function (_ref) {
  var _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'relative' : _ref$position,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? 'accent' : _ref$backgroundColor,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? 'bodyInverse' : _ref$textColor,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? '45px' : _ref$borderRadius,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? 'inline-flex' : _ref$display,
    _ref$alignItems = _ref.alignItems,
    alignItems = _ref$alignItems === void 0 ? 'center' : _ref$alignItems,
    _ref$alignContent = _ref.alignContent,
    alignContent = _ref$alignContent === void 0 ? 'center' : _ref$alignContent,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === void 0 ? 'center' : _ref$textAlign,
    _ref$isCircle = _ref.isCircle,
    isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle,
    elWidth = _ref.elWidth,
    typoSize = _ref.typoSize,
    size = _ref.size,
    padding = _ref.padding,
    elHeight = _ref.elHeight,
    theme = _ref.theme;
  return attachDataAttr('badge')({
    typoSize: typoSize || getSizeProps(theme.baseUnit, size).typoSize,
    padding: padding || getSizeProps(theme.baseUnit, size).padding,
    elHeight: elHeight || getSizeProps(theme.baseUnit, size).elHeight,
    elWidth: elWidth || isCircle ? getSizeProps(theme.baseUnit, size).elHeight : 'auto',
    position: position,
    backgroundColor: backgroundColor,
    textColor: textColor,
    borderRadius: borderRadius,
    display: display,
    alignItems: alignItems,
    alignContent: alignContent,
    textAlign: textAlign
  });
})(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n"])));
Badge.displayName = 'Badge';
Badge.propTypes = _objectSpread$4({}, Badge.propTypes);

var _templateObject$1;
function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var sliderStyles = function sliderStyles(_ref) {
  var theme = _ref.theme;
  return css(["appearance:none;margin:18px 0;width:100%;transition:all 250ms cubic-bezier(0.075,0.82,0.165,1);&:focus{outline:none;}&:active{&::-webkit-slider-thumb{background:", ";box-shadow:", ";transition:all 250ms cubic-bezier(0.075,0.82,0.165,1);}&::-webkit-slider-runnable-track{background:", ";transition:all 250ms cubic-bezier(0.075,0.82,0.165,1);}}&::-webkit-slider-runnable-track{width:100%;height:", "px;cursor:pointer;box-shadow:", ";background:", ";border-radius:", ";transition:all 250ms cubic-bezier(0.075,0.82,0.165,1);}&::-webkit-slider-thumb{box-shadow:", ";height:", "px;width:", "px;border-radius:", ";background:", ";cursor:pointer;appearance:none;margin-top:-", "px;transition:all 250ms cubic-bezier(0.075,0.82,0.165,1);}&::-moz-range-track{width:100%;height:8.4px;cursor:pointer;animate:0.2s;box-shadow:", ";background:#3071a9;border-radius:1.3px;border:0.2px solid #010101;}&::-moz-range-thumb{box-shadow:", ";border:1px solid #000000;height:36px;width:16px;border-radius:3px;background:#ffffff;cursor:pointer;}&::-ms-track{width:100%;height:8.4px;cursor:pointer;animate:0.2s;background:transparent;border-color:transparent;border-width:16px 0;color:transparent;}&::-ms-fill-lower{background:#2a6495;border:0.2px solid #010101;border-radius:2.6px;box-shadow:", ";}&::-ms-fill-upper{background:#3071a9;border:0.2px solid #010101;border-radius:2.6px;box-shadow:", ";}&::-ms-thumb{box-shadow:", ";border:1px solid #000000;height:36px;width:16px;border-radius:3px;background:#ffffff;cursor:pointer;}&:focus::-ms-fill-lower{background:#3071a9;}&:focus::-ms-fill-upper{background:#367ebd;}"], theme.colors.accent, theme.boxShadows.high, theme.colors.ambientLight, theme.baseUnit, theme.boxShadows["default"], theme.colors.ambient, theme.borders.radius["default"], theme.boxShadows.raised, theme.baseUnit * 2.5, theme.baseUnit * 2.5, theme.borders.radius["default"], theme.colors.ambientLight, theme.baseUnit / 1.4, theme.boxShadows["default"], theme.boxShadows["default"], theme.boxShadows["default"], theme.boxShadows["default"], theme.boxShadows["default"]);
};
var Slider = Slate.input.attrs(function (props) {
  return attachDataAttr('slider')({
    type: 'range'
  });
})(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n\t", ";\n"])), sliderStyles);
Slider.displayName = 'Slider';
Slider.propTypes = _objectSpread$3({}, Slider.propTypes);

var _excluded$8 = ["type"],
  _excluded2 = ["children"];
function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Title = function Title(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'H4' : _ref$type,
    rest = _objectWithoutProperties(_ref, _excluded$8);
  var Title = Typography[type];
  return /*#__PURE__*/React.createElement(Div, {
    style: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    marginBottom: "sm"
  }, /*#__PURE__*/React.createElement(Title, _extends({
    display: "inline",
    textColor: "accent"
  }, rest)));
};
var Subtitle = Span;

/**
 * @usage
 *
 * <Heading>
 * 		<Heading.Title>Sample title</Heading.Title>
 * 		<Heading.Subtitle>short description</Heading.Subtitle>
 * </Heading>
 *
 * @param {*} param0
 */
var Heading = function Heading(_ref2) {
  var children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Div, _extends({
    style: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    paddingRight: "md"
  }, props), children);
};
Heading.displayName = 'Heading';
Heading.propTypes = _objectSpread$2({}, Heading.propTypes);
Heading.Title = Title;
Heading.Subtitle = Subtitle;

var _excluded$7 = ["categories", "title", "subtitle", "readMorePath", "image", "imageAlt", "priceRange"];
var EventResult = function EventResult(_ref) {
  var _ref$categories = _ref.categories,
    categories = _ref$categories === void 0 ? [] : _ref$categories,
    title = _ref.title,
    subtitle = _ref.subtitle;
    _ref.readMorePath;
    var image = _ref.image,
    imageAlt = _ref.imageAlt,
    priceRange = _ref.priceRange,
    rest = _objectWithoutProperties(_ref, _excluded$7);
  return /*#__PURE__*/React.createElement(Panel, _extends({
    textDecoration: "none",
    style: {
      overflow: 'hidden'
    }
  }, rest), /*#__PURE__*/React.createElement(Panel.Header, {
    backgroundColor: "bodyInverse",
    padding: "lg",
    display: "flex"
  }, /*#__PURE__*/React.createElement(Thumbnail, {
    src: image,
    alt: imageAlt,
    flexShrink: "0"
  }), /*#__PURE__*/React.createElement(Div, {
    elWidth: "100%",
    marginLeft: "md",
    style: {
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(Heading, {
    marginBottom: "sm",
    textColor: "body"
  }, /*#__PURE__*/React.createElement(Heading.Title, {
    textDecoration: "none",
    typoWeight: "bolder",
    textColor: "body",
    typoSize: "lg"
  }, title), subtitle && /*#__PURE__*/React.createElement(Heading.Subtitle, null, subtitle)))), /*#__PURE__*/React.createElement(Panel.Body, {
    backgroundColor: "bodyInverse",
    paddingTop: "0"
  }, /*#__PURE__*/React.createElement(List, {
    display: "inline-block",
    paddingLeft: "none"
  }, categories.map(function (category, i) {
    return /*#__PURE__*/React.createElement(Tag, {
      key: i,
      as: "li",
      padding: "4px 8px",
      typoSize: "sm",
      textColor: "ambientDark",
      marginRight: "sm"
    }, category);
  })), /*#__PURE__*/React.createElement(Tag, {
    textColor: "body"
  }, priceRange)));
};
var OptimisticEventResult = function OptimisticEventResult() {
  return /*#__PURE__*/React.createElement(Panel, {
    borderRadius: "default",
    backgroundColor: "bodyInverse",
    overflow: "hidden"
  }, /*#__PURE__*/React.createElement(Panel.Header, {
    backgroundColor: "transparent",
    padding: "lg",
    display: "flex"
  }, /*#__PURE__*/React.createElement(Div, {
    optimistic: true,
    borderRadius: "default",
    elHeight: "75px",
    elWidth: "75px"
  }), /*#__PURE__*/React.createElement(Div, {
    optimistic: true,
    elWidth: "100%",
    marginLeft: "md",
    borderRadius: "default",
    style: {
      overflow: 'hidden'
    }
  })), /*#__PURE__*/React.createElement(Panel.Body, null, /*#__PURE__*/React.createElement(Tag, {
    optimistic: true,
    backgroundColor: "ambient",
    elWidth: "100px",
    padding: "md",
    borderColor: "transparent"
  })));
};
EventResult.Optimistic = OptimisticEventResult;

function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var EventList = function EventList(_ref) {
  var _ref$events = _ref.events,
    events = _ref$events === void 0 ? [] : _ref$events,
    _ref$mapPropsToResult = _ref.mapPropsToResult,
    mapPropsToResult = _ref$mapPropsToResult === void 0 ? function (event) {
      return event;
    } : _ref$mapPropsToResult,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$updating = _ref.updating,
    updating = _ref$updating === void 0 ? false : _ref$updating,
    _ref$onClearFilters = _ref.onClearFilters,
    onClearFilters = _ref$onClearFilters === void 0 ? function () {} : _ref$onClearFilters;
  return loading ? /*#__PURE__*/React.createElement(EventResult.Optimistic, null) : events.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(List, {
    bullets: "none"
  }, events.map(function (event) {
    return renderResult(event, mapPropsToResult);
  })), updating && /*#__PURE__*/React.createElement(EventResult.Optimistic, null)) : /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(Panel.Body, {
    textAlign: "center",
    paddingBottom: "xlg"
  }, /*#__PURE__*/React.createElement(Heading, null, /*#__PURE__*/React.createElement(Heading.Title, {
    type: "H3",
    typoSize: "lg"
  }, "We couldn't find anything"), /*#__PURE__*/React.createElement(Heading.Subtitle, {
    as: P
  }, "Try using less specific search terms or filters to get more results")), /*#__PURE__*/React.createElement(Button, {
    textColor: "accent",
    backgroundColor: "bodyInverse",
    onClick: onClearFilters
  }, "Clear search and filters")));
};
function renderResult(event, mapFn) {
  var props = mapFn(event);
  return /*#__PURE__*/React.createElement(EventResult, _extends({
    key: event.Id,
    marginBottom: "md"
  }, props));
}
EventList.displayName = 'EventList';
EventList.propTypes = _objectSpread$1({}, EventList.propTypes);

var _excluded$6 = ["buttons"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ButtonGroup = function ButtonGroup(_ref) {
  var _ref$buttons = _ref.buttons,
    buttons = _ref$buttons === void 0 ? [] : _ref$buttons,
    rest = _objectWithoutProperties(_ref, _excluded$6);
  return useMemo(function () {
    return /*#__PURE__*/React.createElement(List, _extends({
      paddingLeft: "none"
    }, rest), buttons.map(function (button, index) {
      return /*#__PURE__*/React.createElement(List.Item, {
        key: index,
        display: ['block', 'inline-block'],
        marginTop: index !== 0 ? 'none' : button.marginTop,
        marginBottom: index === 0 ? ['sm', 'none'] : '',
        marginRight: index === 0 ? ['none', 'md'] : '',
        elWidth: ['100%', 'auto']
      }, /*#__PURE__*/React.createElement(Button, _extends({
        elWidth: ['100%', 'auto']
      }, button)));
    }));
  }, []);
};
ButtonGroup.displayName = 'ButtonGroup';
ButtonGroup.propTypes = _objectSpread(_objectSpread({}, ButtonGroup.propTypes), {}, {
  button: PropTypes.array
  /** @todo: more props here */
});

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var Table = Slate.table.attrs(function (_ref) {
  var borderRadius = _ref.borderRadius,
    shadow = _ref.shadow;
  return attachDataAttr('table')({
    borderRadius: borderRadius || 'default',
    shadow: shadow || 'default'
  });
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\toverflow: hidden;\n\t\tborder-collapse: collapse;\n"])));
Table.displayName = 'Table';
Table.Row = Slate.tr.attrs(function (_ref2) {
  var padding = _ref2.padding,
    borderColor = _ref2.borderColor,
    borderWidth = _ref2.borderWidth,
    backgroundColor = _ref2.backgroundColor;
  return attachDataAttr('tr')({
    padding: padding || 'md',
    backgroundColor: backgroundColor || 'bodyInverse',
    borderColor: borderColor || 'ambient',
    borderWidth: borderWidth || '0 0 1px 0'
  });
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
Table.Row.displayName = 'Table.Row';
var rowColorOverrideStyles = function rowColorOverrideStyles(_ref3) {
  _ref3.theme;
  return css(["& > ", "{background-color:transparent;}"], Table.Row);
};
Table.Header = Slate.thead.attrs(function (_ref4) {
  var backgroundColor = _ref4.backgroundColor;
    _ref4.typoWeight;
  return attachDataAttr('thead')({
    backgroundColor: backgroundColor || 'ambient'
  });
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), rowColorOverrideStyles);
Table.Header.displayName = 'Table.Header';
Table.Footer = Slate.tfoot.attrs(function (_ref5) {
  var backgroundColor = _ref5.backgroundColor;
  return attachDataAttr('tfoot')({
    backgroundColor: backgroundColor || 'ambient'
  });
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), rowColorOverrideStyles);
Table.Footer.displayName = 'Table.Footer';
var bodyStyles = function bodyStyles(_ref6) {
  var theme = _ref6.theme;
  return css(["& > ", ":nth-child(even){background-color:", ";}& > ", ":hover{background-color:", ";}"], Table.Row, theme.colors.ambientLight, Table.Row, theme.colors.brandLight);
};
Table.Body = Slate.tbody.attrs(function (_ref7) {
  var backgroundColor = _ref7.backgroundColor;
  return attachDataAttr('tbody')({
    backgroundColor: backgroundColor || 'bodyInverse'
  });
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), bodyStyles);
Table.Body.displayName = 'Table.Body';
Table.Cell = Slate.td.attrs(function (_ref8) {
  var padding = _ref8.padding,
    border = _ref8.border;
  return attachDataAttr('td')({
    padding: padding || 'md',
    border: border || 'none'
  });
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral([""])));
Table.Cell.displayName = 'Table.Cell';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

var _typeof$1 = {exports: {}};

(function (module) {
function _typeof(o) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(_typeof$1));

var regeneratorRuntime$1 = {exports: {}};

(function (module) {
var _typeof = _typeof$1.exports["default"];
function _regeneratorRuntime() {

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(regeneratorRuntime$1));

var _typeof = _typeof$1.exports;
// TODO(Babel 8): Remove this file.

var runtime = regeneratorRuntime$1.exports();
var regenerator = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if ((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

var reactIconsKit = {};

var Icon = {};

var SvgIcon = {};

/**
 * Special language-specific overrides.
 *
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 *
 * @type {Object}
 */

var LANGUAGES$1 = {
  tr: {
    regexp: /[\u0069]/g,
    map: {
      "i": "\u0130"
    }
  },
  az: {
    regexp: /[\u0069]/g,
    map: {
      "i": "\u0130"
    }
  },
  lt: {
    regexp: /[\u0069\u006A\u012F]\u0307|\u0069\u0307[\u0300\u0301\u0303]/g,
    map: {
      "i\u0307": "I",
      "j\u0307": "J",
      "\u012F\u0307": "\u012E",
      "i\u0307\u0300": "\xCC",
      "i\u0307\u0301": "\xCD",
      "i\u0307\u0303": "\u0128"
    }
  }
};

/**
 * Upper case a string.
 *
 * @param  {String} str
 * @return {String}
 */
var upperCase$1 = function (str, locale) {
  var lang = LANGUAGES$1[locale];
  str = str == null ? '' : String(str);
  if (lang) {
    str = str.replace(lang.regexp, function (m) {
      return lang.map[m];
    });
  }
  return str.toUpperCase();
};

/**
 * Special language-specific overrides.
 *
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 *
 * @type {Object}
 */

var LANGUAGES = {
  tr: {
    regexp: /\u0130|\u0049|\u0049\u0307/g,
    map: {
      "\u0130": "i",
      "I": "\u0131",
      "I\u0307": "i"
    }
  },
  az: {
    regexp: /[\u0130]/g,
    map: {
      "\u0130": "i",
      "I": "\u0131",
      "I\u0307": "i"
    }
  },
  lt: {
    regexp: /[\u0049\u004A\u012E\u00CC\u00CD\u0128]/g,
    map: {
      "I": "i\u0307",
      "J": "j\u0307",
      "\u012E": "\u012F\u0307",
      "\xCC": "i\u0307\u0300",
      "\xCD": "i\u0307\u0301",
      "\u0128": "i\u0307\u0303"
    }
  }
};

/**
 * Lowercase a string.
 *
 * @param  {String} str
 * @return {String}
 */
var lowerCase$1 = function (str, locale) {
  var lang = LANGUAGES[locale];
  str = str == null ? '' : String(str);
  if (lang) {
    str = str.replace(lang.regexp, function (m) {
      return lang.map[m];
    });
  }
  return str.toLowerCase();
};

var nonWordRegexp = /[^A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+/g;

var camelCaseRegexp = /([a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19])([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A])/g;

var camelCaseUpperRegexp = /([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A])([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A][a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A])/g;

var lowerCase = lowerCase$1;
var NON_WORD_REGEXP = nonWordRegexp;
var CAMEL_CASE_REGEXP = camelCaseRegexp;
var CAMEL_CASE_UPPER_REGEXP = camelCaseUpperRegexp;

/**
 * Sentence case a string.
 *
 * @param  {string} str
 * @param  {string} locale
 * @param  {string} replacement
 * @return {string}
 */
var noCase$1 = function (str, locale, replacement) {
  if (str == null) {
    return '';
  }
  replacement = typeof replacement !== 'string' ? ' ' : replacement;
  function replace(match, index, value) {
    if (index === 0 || index === value.length - match.length) {
      return '';
    }
    return replacement;
  }
  str = String(str)
  // Support camel case ("camelCase" -> "camel Case").
  .replace(CAMEL_CASE_REGEXP, '$1 $2')
  // Support odd camel case ("CAMELCase" -> "CAMEL Case").
  .replace(CAMEL_CASE_UPPER_REGEXP, '$1 $2')
  // Remove all non-word characters and replace with a single space.
  .replace(NON_WORD_REGEXP, replace);

  // Lower case the entire string.
  return lowerCase(str, locale);
};

var upperCase = upperCase$1;
var noCase = noCase$1;

/**
 * Camel case a string.
 *
 * @param  {string} value
 * @param  {string} [locale]
 * @return {string}
 */
var camelCase = function (value, locale, mergeNumbers) {
  var result = noCase(value, locale);

  // Replace periods between numeric entities with an underscore.
  if (!mergeNumbers) {
    result = result.replace(/ (?=\d)/g, '_');
  }

  // Replace spaces between words with an upper cased character.
  return result.replace(/ (.)/g, function (m, $1) {
    return upperCase($1, locale);
  });
};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SvgIcon = void 0;
var _react = _interopRequireWildcard(React);
var _propTypes = _interopRequireDefault(PropTypes);
var _camelCase = _interopRequireDefault(camelCase);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj["default"] = obj;
    return newObj;
  }
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var walkChildren = function walkChildren(children) {
  return children.map(function (child, idx) {
    var name = child.name,
      attribsMap = child.attribs,
      _child$children = child.children,
      gchildren = _child$children === void 0 ? null : _child$children; //fill, stroke

    var attribs = Object.keys(attribsMap).filter(function (key) {
      return key !== 'fill' && key !== 'stroke' && attribsMap[key] !== 'none';
    }).reduce(function (partial, key) {
      partial[(0, _camelCase["default"])(key)] = attribsMap[key];
      return partial;
    }, {}); //special case, it has fill and stroke at the same time

    var merge = {};
    if (attribsMap.fill === 'none' && attribsMap.stroke) {
      merge = {
        fill: 'none',
        stroke: 'currentColor'
      };
    }
    return (0, _react.createElement)(name, _objectSpread({
      key: idx
    }, attribs, merge), gchildren === null ? gchildren : walkChildren(gchildren));
  });
};
var SvgIcon = function SvgIcon(props) {
  var size = props.size;
  var _props$icon = props.icon,
    children = _props$icon.children,
    viewBox = _props$icon.viewBox,
    _props$icon$attribs = _props$icon.attribs,
    svgAttribs = _props$icon$attribs === void 0 ? {} : _props$icon$attribs;
  var camelCasedAttribs = Object.keys(svgAttribs).reduce(function (partial, key) {
    partial[(0, _camelCase["default"])(key)] = svgAttribs[key];
    return partial;
  }, {});
  return _react["default"].createElement("svg", _extends({
    fill: "currentColor",
    style: {
      display: 'inline-block',
      verticalAlign: 'middle'
    },
    height: size,
    width: size,
    viewBox: viewBox
  }, camelCasedAttribs), props.title ? _react["default"].createElement("title", null, props.title) : null, walkChildren(children));
};
exports.SvgIcon = SvgIcon;
SvgIcon.defaultProps = {
  size: 16
};
SvgIcon.propTypes = {
  icon: _propTypes["default"].object.isRequired,
  size: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  title: _propTypes["default"].string
};
var _default = SvgIcon;
exports["default"] = _default;
}(SvgIcon));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.withBaseIcon = exports.Icon = void 0;
var _react = _interopRequireDefault(React);
var _propTypes = _interopRequireDefault(PropTypes);
var _SvgIcon = _interopRequireDefault(SvgIcon);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var Icon = function Icon(props) {
  var style = props.style,
    className = props.className;
    props.icon;
    props.size;
    var tag = props.tag,
    others = _objectWithoutProperties(props, ["style", "className", "icon", "size", "tag"]); //eslint-disable-line

  var Tag = tag;
  return _react["default"].createElement(Tag, _extends({}, others, {
    style: _objectSpread({
      display: 'inline-block'
    }, style),
    className: className
  }), _react["default"].createElement(_SvgIcon["default"], {
    size: props.size,
    icon: props.icon,
    title: props.title
  }));
};
exports.Icon = Icon;
var withBaseIcon = function withBaseIcon(defaultProps) {
  return function (props) {
    var propsToUse = _objectSpread({}, defaultProps);
    return _react["default"].createElement(Icon, _extends({}, propsToUse, props));
  };
};
exports.withBaseIcon = withBaseIcon;
Icon.defaultProps = {
  size: 16,
  fill: 'currentColor',
  tag: 'i'
};
Icon.propTypes = {
  icon: _propTypes["default"].object.isRequired,
  size: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  style: _propTypes["default"].object,
  tag: _propTypes["default"].oneOf(['i', 'span', 'div']),
  className: _propTypes["default"].string
};
var _default = Icon;
exports["default"] = _default;
}(Icon));

var horizontalCenter = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.horizontalCenter = void 0;
var _react = _interopRequireWildcard(React);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj["default"] = obj;
    return newObj;
  }
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var horizontalCenter = function horizontalCenter(Component) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$rAlign = _ref.rAlign,
    rAlign = _ref$rAlign === void 0 ? false : _ref$rAlign,
    _ref$space = _ref.space,
    space = _ref$space === void 0 ? 4 : _ref$space;
  return function (props) {
    return _react["default"].createElement(Component, props, _react["default"].createElement("div", {
      style: {
        display: 'inline-flex',
        justifyContent: 'center',
        'alignItems': 'center'
      }
    }, _react.Children.toArray(props.children).map(function (child, idx) {
      var spacerField = rAlign ? 'paddingLeft' : 'paddingRight';
      return _react["default"].createElement("div", {
        key: idx,
        style: _defineProperty({
          display: 'inline-block'
        }, spacerField, space)
      }, child);
    })));
  };
};
exports.horizontalCenter = horizontalCenter;
var _default = horizontalCenter;
exports["default"] = _default;
}(horizontalCenter));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Icon", {
  enumerable: true,
  get: function get() {
    return _Icon.Icon;
  }
});
Object.defineProperty(exports, "withBaseIcon", {
  enumerable: true,
  get: function get() {
    return _Icon.withBaseIcon;
  }
});
Object.defineProperty(exports, "horizontalCenter", {
  enumerable: true,
  get: function get() {
    return _horizontalCenter.horizontalCenter;
  }
});
exports["default"] = void 0;
var _Icon = Icon;
var _horizontalCenter = horizontalCenter;
var _default = _Icon.Icon;
exports["default"] = _default;
}(reactIconsKit));

var _excluded$5 = ["size", "kit", "iconName"];

/**
 * @module BaseIcon
 * @category Components
 * @subcategory Presentational
 * @description
 * This file can be narrowed down to just one generic icon component, but doing this for convenience.  It does make the bundle a bit bigger and doesn't take advantage of code splitting
 * but the semantics and readability of it are very useful.  it will also give us a single point for changing icons in case we want to switch later on.
 */

/**
 * @typedef IconSize
 * @property {number} [size = 24] the icon size
 */

/**
 * @param {module:BaseIcon~IconSize} props
 * @description
 * A + icon.
 * @component
 * @example
 * return (<AddIcon size={36}/>)
 * @todo
 * document this and the other icons
 */
var BaseIcon = function BaseIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    _ref$kit = _ref.kit,
    kit = _ref$kit === void 0 ? 'md' : _ref$kit,
    iconName = _ref.iconName,
    rest = _objectWithoutProperties(_ref, _excluded$5);
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    icon = _useState2[0],
    setIcon = _useState2[1];
  useEffect(function () {
    loadIcon();
  }, []);
  var loadIcon = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var obj;
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return import("react-icons-kit/".concat(kit, "/").concat(iconName));
          case 3:
            obj = _context.sent;
            setIcon(obj[iconName]);
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function loadIcon() {
      return _ref2.apply(this, arguments);
    };
  }();
  return icon ? /*#__PURE__*/React.createElement(Span, _extends({
    as: reactIconsKit.Icon,
    icon: icon,
    size: size,
    typoWeight: 'bold',
    display: "inline-flex !important",
    alignItems: "center"
  }, rest)) : null;
};

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}

var IconButton = styled(Button).attrs(function (_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    _ref$grid = _ref.grid,
    grid = _ref$grid === void 0 ? true : _ref$grid,
    _ref$gridColumns = _ref.gridColumns,
    gridColumns = _ref$gridColumns === void 0 ? 'repeat(3, 1fr)' : _ref$gridColumns,
    _ref$alignItems = _ref.alignItems,
    alignItems = _ref$alignItems === void 0 ? 'center' : _ref$alignItems,
    _ref$justifyContent = _ref.justifyContent,
    justifyContent = _ref$justifyContent === void 0 ? 'center' : _ref$justifyContent,
    theme = _ref.theme;
  return attachDataAttr('icon-button')({
    type: type,
    grid: grid,
    gridColumns: gridColumns,
    alignItems: alignItems,
    justifyContent: justifyContent,
    theme: theme
  });
}).withConfig({
  displayName: "IconButton",
  componentId: "sc-e323f1-0"
})([""]);
IconButton.Text = styled(Span).attrs(function (_ref2) {
  _objectDestructuringEmpty(_ref2);
  return attachDataAttr('icon-button__text')({});
}).withConfig({
  displayName: "IconButton__Text",
  componentId: "sc-e323f1-1"
})([""]);
IconButton.Icon = styled(Span).attrs(function (_ref3) {
  var _ref3$typoWeight = _ref3.typoWeight,
    typoWeight = _ref3$typoWeight === void 0 ? 'bold' : _ref3$typoWeight,
    _ref3$display = _ref3.display,
    display = _ref3$display === void 0 ? 'inline-flex !important' : _ref3$display,
    _ref3$alignItems = _ref3.alignItems,
    alignItems = _ref3$alignItems === void 0 ? 'center' : _ref3$alignItems;
  return attachDataAttr('icon-button__icon')({
    typoWeight: typoWeight,
    display: display,
    alignItems: alignItems
  });
}).withConfig({
  displayName: "IconButton__Icon",
  componentId: "sc-e323f1-2"
})([""]);
IconButton.displayName = 'IconButton';
IconButton.Text.displayName = 'IconButton.Text';
IconButton.Icon.displayName = 'IconButton.Icon';

var _excluded$4 = ["type", "label", "placeholder", "unlockLabel", "termsAndConditionsURL", "privacyPolicyURL", "onSubmit"];
var CodeUnlocker = function CodeUnlocker(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'email' : _ref$type,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Your Email Address' : _ref$label,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'user@email.com' : _ref$placeholder,
    _ref$unlockLabel = _ref.unlockLabel,
    unlockLabel = _ref$unlockLabel === void 0 ? 'Activate Offer' : _ref$unlockLabel;
    _ref.termsAndConditionsURL;
    _ref.privacyPolicyURL;
    var onSubmit = _ref.onSubmit,
    rest = _objectWithoutProperties(_ref, _excluded$4);
  return /*#__PURE__*/React.createElement("form", _extends({
    onSubmit: onSubmit
  }, rest), /*#__PURE__*/React.createElement(InputGroup, {
    elWidth: "100%",
    marginBottom: "md"
  }, /*#__PURE__*/React.createElement(InputGroup.Label, null, label), /*#__PURE__*/React.createElement(InputGroup.Fields, {
    paddingLeft: "md"
  }, /*#__PURE__*/React.createElement(InputGroup.Input, {
    type: type,
    placeholder: placeholder
  }))), /*#__PURE__*/React.createElement(IconButton, {
    type: "submit",
    iconName: "ic_lock_open",
    text: unlockLabel,
    backgroundColor: "accent",
    textColor: "bodyInverse",
    elWidth: "100%"
  }), /*#__PURE__*/React.createElement(P, null, /*#__PURE__*/React.createElement(Span, {
    as: "small"
  }, "By activating this offer, I confirm I have read and agree to the", ' ', /*#__PURE__*/React.createElement(A, {
    href: "https://icecreamsocial.io",
    target: "_blank",
    textColor: "body",
    visitedTextColor: "body"
  }, "Terms and Conditions"), ' ', "and", ' ', /*#__PURE__*/React.createElement(A, {
    href: "https://icecreamsocial.io",
    target: "_blank",
    textColor: "body",
    visitedTextColor: "body"
  }, "Privacy Policy"), ". I agree that my information may be shared as stated in the Privacy Policy.")));
};

var Circle = styled(Div).attrs(function (_ref) {
  var _ref$display = _ref.display,
    display = _ref$display === void 0 ? 'flex' : _ref$display,
    _ref$alignItems = _ref.alignItems,
    alignItems = _ref$alignItems === void 0 ? 'center' : _ref$alignItems,
    _ref$justifyContent = _ref.justifyContent,
    justifyContent = _ref$justifyContent === void 0 ? 'center' : _ref$justifyContent,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === void 0 ? 'center' : _ref$textAlign,
    _ref$elWidth = _ref.elWidth,
    elWidth = _ref$elWidth === void 0 ? '40px' : _ref$elWidth,
    _ref$elHeight = _ref.elHeight,
    elHeight = _ref$elHeight === void 0 ? '40px' : _ref$elHeight,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? '50%' : _ref$borderRadius,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? 'brand' : _ref$backgroundColor,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? 'bodyInverse' : _ref$textColor,
    theme = _ref.theme;
  return attachDataAttr('circle')({
    display: display,
    alignItems: alignItems,
    justifyContent: justifyContent,
    textAlign: textAlign,
    elWidth: elWidth,
    elHeight: elHeight,
    borderRadius: borderRadius,
    backgroundColor: backgroundColor,
    textColor: textColor,
    theme: theme
  });
}).withConfig({
  displayName: "Circle",
  componentId: "sc-70bvid-0"
})([""]);

var _excluded$3 = ["link", "onCopy"];

/**
 * @todo load FB SDK
 */
var FacebookShare = function FacebookShare(_ref) {
  _ref.link;
    var onCopy = _ref.onCopy;
    _objectWithoutProperties(_ref, _excluded$3);
  return /*#__PURE__*/React.createElement(IconButton, {
    type: "button",
    kit: "fa",
    iconName: "facebookOfficial",
    text: "Facebook",
    backgroundColor: "#1778f2",
    textColor: "bodyInverse",
    onClick: function onClick() {
      return copy$1(onCopy);
    }
  });
};

/**
 * simple implementation of copying based on https://www.w3schools.com/howto/howto_js_copy_clipboard.asp
 * @param {function} onCopy callback once copy is called
 */
function copy$1() {
  var onCopy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var toCopy = document.getElementById(SHARE_LINK_ID);
  toCopy.select();
  toCopy.setSelectionRange(0, 99999); // for mobile

  document.execCommand('copy');
  onCopy(toCopy.value);
}

var _excluded$2 = ["loader", "srcList"];
var FadeIn = keyframes(["from{opacity:0;}to{opacity:1;}"]);
var AnimatedImage = styled(Img).withConfig({
  displayName: "ImageLoader__AnimatedImage",
  componentId: "sc-15rsp8-0"
})(["animation:", " 300ms ease;"], FadeIn);

/**
 * Very opinionated image loader.  Will automatically fade the image in when loaded
 * @param {*} param0
 */
var ImageLoader = function ImageLoader(_ref) {
  var loader = _ref.loader,
    srcList = _ref.srcList,
    rest = _objectWithoutProperties(_ref, _excluded$2);
  var _useImage = useImage({
      useSuspense: false,
      srcList: srcList
    }),
    src = _useImage.src,
    isLoading = _useImage.isLoading;
  return isLoading ? loader(isLoading) : /*#__PURE__*/React.createElement(AnimatedImage, _extends({
    src: src
  }, rest));
};

var _excluded$1 = ["link", "onCopy"];

/**
 * @todo load FB SDK
 */
var MessengerShare = function MessengerShare(_ref) {
  _ref.link;
    var onCopy = _ref.onCopy,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  return /*#__PURE__*/React.createElement(IconButton, _extends({
    type: "button",
    kit: "fa",
    iconName: "facebookOfficial",
    text: "Messenger",
    border: "none",
    textColor: "bodyInverse",
    backgroundColor: "#1778f2",
    backgroundGradientColor: "95.94deg, #0088ff 0%, #a033ff 39%, #ff5c87 100%",
    style: {
      backgroundPosition: 'center center',
      backgroundSize: 'cover'
    },
    onClick: function onClick() {
      return copy(onCopy);
    }
  }, rest));
};

/**
 * simple implementation of copying based on https://www.w3schools.com/howto/howto_js_copy_clipboard.asp
 * @param {function} onCopy callback once copy is called
 */
function copy() {
  var onCopy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var toCopy = document.getElementById(SHARE_LINK_ID);
  toCopy.select();
  toCopy.setSelectionRange(0, 99999); // for mobile

  document.execCommand('copy');
  onCopy(toCopy.value);
}

var _excluded = ["link", "onCopy", "label"];
var ShareLink = function ShareLink(_ref) {
  var link = _ref.link,
    onCopy = _ref.onCopy,
    label = _ref.label,
    rest = _objectWithoutProperties(_ref, _excluded);
  var linkRef = useRef(null);
  /**
   * simple memoized implementation of copying based on https://www.w3schools.com/howto/howto_js_copy_clipboard.asp
   * @param {function} onCopy callback once copy is called
   */
  var copy = function copy() {
    linkRef.current.select();
    linkRef.current.setSelectionRange(0, 99999); // for mobile

    document.execCommand('copy');
    onCopy(linkRef.current.value);
  };
  return /*#__PURE__*/React.createElement(InputGroup, _extends({
    display: "block",
    elWidth: "100%"
  }, rest), label && /*#__PURE__*/React.createElement(InputGroup.Label, null, label), /*#__PURE__*/React.createElement(InputGroup.Fields, {
    backgroundColor: "ambient",
    padding: "sm",
    border: "none"
  }, /*#__PURE__*/React.createElement(InputGroup.Input, {
    ref: linkRef,
    value: link,
    marginLeft: "sm",
    textDecoration: "underline",
    readOnly: true
  }), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    display: "flex",
    alignItems: "center",
    backgroundColor: "accent",
    textColor: "bodyInverse",
    borderRadius: "32px",
    style: {
      gap: '8px'
    },
    onClick: copy
  }, /*#__PURE__*/React.createElement(BaseIcon, {
    iconName: "ic_content_copy",
    size: 20
  }), /*#__PURE__*/React.createElement(Span, null, "Copy"))));
};

export { Badge, BaseIcon, Button, ButtonGroup, Circle, CodeUnlocker, Container, Div, EventList, FacebookShare, index as Globals, GridLayout, Heading, Hero, IconButton, ImageLoader, Img, Input, InputGroup, List, MediaCard, MessengerShare, SlateModal as Modal, ModalBackground, Navbar, Panel, index$1 as Reset, ScriptLoader, Select, ShareLink, Slate, Slider, Spanner, SuspensefulImg, Table, Tag, Thumbnail, Typography };
